import * as tslib_1 from "tslib";
import { Component, Vue } from "vue-property-decorator";
import TransferDialog from "./TransferDialog.vue";
import SelectClassify from "@/components/SelectClassify/index.vue";
import { TestPaperEditorModule } from "@/store/modules/test-paper-editor";
import { getPaperCategoryList } from "@/api/test-paper";
import { AppModule } from "@/store/modules/app";
let PaperInfo = class PaperInfo extends Vue {
    constructor() {
        super(...arguments);
        this.hasShowTreeModal = false;
        this.operateTitle = "修改分类";
        this.libTreeData = [];
        this.btnLoading = false;
        this.libLoading = false;
        this.checkedLib = {};
    }
    get paperTitle() {
        return TestPaperEditorModule.paperTitle;
    }
    get paperLibId() {
        return TestPaperEditorModule.paperLibraryId;
    }
    get paperLibName() {
        return TestPaperEditorModule.paperlibraryName;
    }
    get paperId() {
        return TestPaperEditorModule.paperId;
    }
    get isSidebarExpanded() {
        return AppModule.sidebar.opened;
    }
    created() {
    }
    paperTitleInput(evt) {
        const value = evt.target.value;
        TestPaperEditorModule.setPaperBaseInfo({
            ...TestPaperEditorModule.baseInfo,
            paperTitle: value.replace(/(^\s*)|(\s*$)/g, "")
        });
    }
    next() {
        if (!this.paperTitle) {
            return this.$message.error("请填写试卷名称");
        }
        if (this.paperLibId === '') {
            return this.$message.error("请选择试卷分类");
        }
        this.$router.push({
            name: "TestPaperEdit",
            query: {
                step: '2',
                paper_id: this.paperId || '',
                exam_id: this.$route.query.exam_id || ''
            }
        });
        // window.parent.postMessage({
        //   cmd: 'goSecondStep',
        //   params: {}
        // }, window.location.origin)
    }
    cancel() {
        const examId = this.$route.query.exam_id;
        const paperId = this.paperId || "";
        if (examId) {
            // var n = "/t/exam/examination#/examIndex/editExam?exam_id=".concat(examId, "&paperId=").concat(paperId, "&step=2");
            // window.location.href = n
        }
        else {
            this.$router.push({
                name: "TestPaper"
            });
        }
    }
    async modifyLibId() {
        this.hasShowTreeModal = true;
        try {
            const res = await getPaperCategoryList();
            this.libTreeData = res.data.data;
        }
        catch (_) { }
    }
    handleConfirm() {
        if (!this.checkedLib.id)
            return this.$message.error("请先选择一个分类");
        TestPaperEditorModule.setPaperBaseInfo({
            ...TestPaperEditorModule.baseInfo,
            paperLibraryId: this.checkedLib.id,
            paperLibraryName: this.checkedLib.name
        });
        this.hasShowTreeModal = false;
    }
    cancelLibModal() {
        this.checkedLib = null;
        this.hasShowTreeModal = !1;
    }
    handleTreeNodeClick(nodeData) {
        this.checkedLib = nodeData;
    }
};
PaperInfo = tslib_1.__decorate([
    Component({
        name: 'PaperInfo',
        components: {
            TransferDialog,
            SelectClassify
        }
    })
], PaperInfo);
export default PaperInfo;
